import { fetchy } from '@bridebook/web/lib/fetchy';
import type { TrackEventBodyWeb } from '@bridebook/toolbox/src/types';
import getServerSideAnalyticsProps from '@bridebook/web/lib/utils/get-server-side-analytics-props';
import type { IServerSideTrack } from '@bridebook/web/lib/utils/server-side-track';
import { weddingDetailsPropertiesGeneric } from '@bridebook/web/lib/weddings/analytics';

const collaboratingSupplierTrack = ({
  state,
  event,
  identifyProps,
  specificEventProps,
  category = '',
  collaboratingSupplierId,
}: IServerSideTrack) => {
  const body: TrackEventBodyWeb = {
    event,
    identifyProps,
    genericProps: getServerSideAnalyticsProps(state),
    specificEventProps: {
      ...weddingDetailsPropertiesGeneric(state),
      weddingId: state.weddings.profile?.id,
      userEmail: state.users.user?.contacts?.email,
      ...specificEventProps,
    },
    source: 'web',
    category,
    collaboratingSupplierId,
  };

  return fetchy().post('/api/a/t/collaborating', null, body);
};

export default collaboratingSupplierTrack;
